/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */

/**
 *
 *
 * 1 = Symptoms
 *
 * 2 = CauseOfFailure
 */
export enum TechnicianJobDescriptionType {
  Symptoms = 1,
  CauseOfFailure = 2,
}
